import { api } from '@/lib/api';
import { mutationOptions, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';
import { queryKeys } from '../queryKeys';
import type {
  MaintenanceStatusResponse,
  ToggleMaintenanceRequest,
} from './maintenanceTypes';

export const useToggleMaintenanceMutation = () => {
  const queryClient = useQueryClient();

  return mutationOptions({
    mutationKey: mutationKeys.adminMaintenance.toggle(),
    mutationFn: async (data: ToggleMaintenanceRequest) => {
      return await api
        .post('admin/maintenance', { json: data })
        .json<MaintenanceStatusResponse>();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.adminMaintenance.status(),
      });
      toast.success(
        `Maintenance mode ${variables.mode ? 'enabled' : 'disabled'}`,
      );
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to toggle maintenance mode');
    },
  });
};
